const getServer = () => {
  let previousServer = "http://localhost:3001/";
  return "https://my-json-server.typicode.com/apostolos172/db-media/";
};

export { getServer };
